import _toFinite from 'lodash/toFinite';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_CARPARK_PRICE_GRIDS,
  CPM_ADD_CARPARK_PRICE_GRID,
  CPM_UPDATE_CARPARK_PRICE_GRID,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/priceGrid';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkPriceGrid;
const cpmCarparkPriceGrid = (state = initialSettings, action) => {
  let key;
  let mutationResult;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullCarpark' || action.target === 'currentCarpark') {
        return {
          ...state,
          list: { ...initialSettings.list },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
        };
      }
      switch (action.target) {
        case 'addCarparkPriceGrid':
          key = 'add';
          break;
        case 'updateCarparkPriceGrid':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST PRICE GRIDS
    case CPM_GET_CARPARK_PRICE_GRIDS:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: null,
        },
      };
    case `${CPM_GET_CARPARK_PRICE_GRIDS}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_PRICE_GRIDS}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.listPriceGrids),
          loading: false,
        },
      };
    // ADD PRICE GRID
    case CPM_ADD_CARPARK_PRICE_GRID:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_ADD_CARPARK_PRICE_GRID}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_ADD_CARPARK_PRICE_GRID}_SUCCESS`:
      mutationResult = action.data.addPriceGrid;
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    // UPDATE PRICE GRID
    case CPM_UPDATE_CARPARK_PRICE_GRID:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_UPDATE_CARPARK_PRICE_GRID}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_CARPARK_PRICE_GRID}_SUCCESS`:
      mutationResult = action.data.updatePriceGrid;
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkPriceGrid;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkPriceGrid.js